module.exports = __webpack_public_path__ + "static/media/png.fcc3c867.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/png.svg
// module id = 603
// module chunks = 0